<template>
	<div
		:style="{ width: showInputData || showOuputData ? '900px' : '500px' }"
		id="nodeContentsContainer"
		ref="nodeContentsContainer"
		:class="'nodeContentsModal ' + (visible ? 'show' : 'hide')"
	>
		<div id="wf-tour-input-panel-handle" v-if="isActionNode" @click="toggleInput()" class="inputDataHandle">
			<el-tooltip content="Click the panel to access incoming data" placement="left" effect="dark">
				<img id="wf-tour-input-panel-arrow" class="transferIcon" src="../assets/dataTransferIconIn.svg" />
			</el-tooltip>
		</div>
		<div id="wf-tour-input-data-panel" :class="'inputData ' + (showInputData ? 'showInputData' : '')">
			<incomingDataInterface
				:key="integration.id"
				v-if="showInputData && loadInputDataInterface"
				:integration="integration"
			/>
		</div>
		<div
			:class="
				'paramContentsWrapper ' +
				(!isActionNode || !isNotContextualNode ? 'paramContentsWrapper_additionalWidth' : '')
			"
		>
			<integrationParamsConfigurationForm
				:readOnlyMode="readOnlyMode"
				@close="close"
				:workflow="workflow"
				ref="integrationParamsConfigurationForm"
			/>
		</div>
		<div id="wf-tour-output-data-panel" :class="'ouputData ' + (showOuputData ? 'showOuputData' : '')">
			<div
				:key="integration.name + 'executionBtn'"
				style="padding: 20px; padding-bottom: 0px"
				v-if="showOuputData && loadOuputDataInterface"
				class="fade-in"
			>
				<el-button
					:disabled="workflow.isActive || readOnlyMode"
					@click="initTestCall()"
					style="width: 100%"
					type="primary"
					plain
					:loading="operationInProgress"
				>
					Test {{ integration ? integration.nodeDescription.displayName : "" }}
					{{ integration && integration.type !== "action" ? "" : "Integration" }}
				</el-button>
			</div>
			<outgoingDataInterface
				:readOnlyMode="readOnlyMode"
				ref="outgoingDataInterface"
				@operationComplete="operationInProgress = false"
				:key="integration.id"
				v-if="showOuputData && loadOuputDataInterface"
				:integration="integration"
				:workflow="workflow"
			/>
		</div>
		<div id="wf-tour-output-panel-handle" :style="{ display: isNotContextualNode ? '' : 'none' }" @click="toggleOuput()" class="outputDataHandle">
			<el-tooltip content="Click the panel to test and access outgoing data" placement="left" effect="dark">
				<img id="wf-tour-output-panel-arrow" class="transferIcon" src="../assets/dataTransferIconOut.svg" />
			</el-tooltip>
		</div>
	</div>
</template>

<script>
import incomingDataInterface from "./incomingDataInterface.vue";
import integrationParamsConfigurationForm from "./integrationParamsConfigurationForm.vue";
import outgoingDataInterface from "./outgoingDataInterface.vue";
export default {
	components: { integrationParamsConfigurationForm, outgoingDataInterface, incomingDataInterface },
	computed: {
		isActionNode() {
			if (this.integration?.type == "action") {
				return true;
			}
			return false;
		},
		isNotContextualNode() {
			if (this.outputs && this.outputs?.length) {
				return false;
			} else {
				return true;
			}
		},
	},
	props: {
		visible: Boolean,
		workflow: Object,
		readOnlyMode: Boolean,
	},
	data() {
		return {
			showInputData: false,
			showOuputData: false,
			loadOuputDataInterface: false,
			loadInputDataInterface: false,
			operationInProgress: false,
			integration: null,
			outputs: [],
		};
	},
	mounted() {
		document.addEventListener("keyup", this.keyPress, true);
	},
	beforeDestroy() {
		document.removeEventListener("keyup", this.keyPress, true);
	},
	methods: {
		loadFormData(integration, inputsOutputs) {
			this.integration = integration;
			this.outputs = inputsOutputs.outputs;
			if (!this.isActionNode) {
				this.loadInputDataInterface = false;
				this.showInputData = false;
			}
			if (!this.isNotContextualNode) {
				this.loadOuputDataInterface = false;
				this.showOuputData = false;
			}
			if (!inputsOutputs.doNotReload) {
				this.$refs.integrationParamsConfigurationForm.loadFormData(integration, inputsOutputs);
			}
		},
		keyPress(e) {
			if (e.key === "Escape") {
				this.close();
			}
		},
		close() {
			this.showOuputData = false;
			this.loadOuputDataInterface = false;
			this.showInputData = false;
			this.loadInputDataInterface = false;
			this.$emit("close");
		},
		toggleInput() {
			this.showInputData = !this.showInputData;
			setTimeout(() => {
				this.loadInputDataInterface = !this.loadInputDataInterface;
			}, 300);
			this.loadOuputDataInterface = false;
			this.showOuputData = false;
		},
		toggleOuput() {
			this.showOuputData = !this.showOuputData;
			setTimeout(() => {
				this.loadOuputDataInterface = !this.loadOuputDataInterface;
			}, 300);
			this.loadInputDataInterface = false;
			this.showInputData = false;
		},
		async initTestCall() {
			this.operationInProgress = true;
			//Saved the current integration data before creating a test webhook
			const status = await this.$refs.integrationParamsConfigurationForm.saveParams(
				"Integration data saved before initiating test"
			);
			if (status === "validationFail") {
				setTimeout(() => {
					this.operationInProgress = false;
					this.$notify({
						title: "Warning",
						message: "Unable to test integration. Required fields missing.",
						type: "warning",
						position: "bottom-left",
					});
				}, 500);
				return;
			}
			this.$refs?.outgoingDataInterface?.initTestCall();
		},
	},
};
</script>

<style scoped>
.nodeContentsModal {
	width: 500px;
	height: calc(100vh - 140px);
	background-color: white;
	position: absolute;
	right: 0px;
	bottom: 0px;
	z-index: 1000;
	transition: 0.3s ease all;
	overflow: hidden;
	cursor: default;
	overflow: visible;
	display: inline-flex;
}

.paramContentsWrapper {
	width: calc(400px - 42px);
	padding-left: 20px;
	padding-right: 20px;
	border-left: 1px solid #e9e9eb;
	border-right: 1px solid #e9e9eb;
	height: 100%;
	overflow-y: auto;
	overflow-x: hidden;
	overscroll-behavior: contain;
}

.paramContentsWrapper_additionalWidth {
	width: 408px;
}

.show {
	right: 0px;
	opacity: 1;
}

.hide {
	opacity: 0;
	right: -500px;
}

.inputDataHandle {
	height: 100%;
	width: 49px;
	background-color: white;
	cursor: pointer;
	display: flex;
	overflow: hidden;
	border-left: 1px solid #e9e9eb;
}

.outputDataHandle {
	height: 100%;
	width: 50px;
	background-color: white;
	cursor: pointer;
	display: flex;
	overflow: hidden;
}

.transferIcon {
	width: 30px;
	margin: auto;
}

.inputData {
	transition: 0.3s ease all;
	border-left: 0px solid white;
	width: 0px;
	height: 100%;
}

.ouputData {
	transition: 0.3s ease all;
	border-right: 0px solid white;
	width: 0px;
	height: 100%;
}

.showInputData {
	height: 100%;
	width: 399px;
	border-left: 1px solid #e9e9eb;
}

.showOuputData {
	height: 100%;
	width: 399px;
	border-right: 1px solid #e9e9eb;
}
</style>
